module.exports = MaterialUI.Dialog;